import { Inject, Injectable } from "@angular/core";
import { AppConfig } from "@app/app.config";
import { appConfigToken } from "@app/app.config.token";

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    appConfig: AppConfig;

    constructor(@Inject(appConfigToken) appConfig: AppConfig) {
        this.appConfig = appConfig;
    }
}
